import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'sv',
  Pagination: {
    items_per_page: '/ sida',
    jump_to: 'Gå till',
    jump_to_confirm: 'bekräfta',
    page: '',
    prev_page: 'Föreg sida',
    next_page: 'Nästa sida',
    prev_5: 'Föreg 5 sidor',
    next_5: 'Nästa 5 sidor',
    prev_3: 'Föreg 3 sidor',
    next_3: 'Nästa 3 sidor',
  },
  DatePicker: {
    lang: {
      placeholder: 'Välj datum',
      yearPlaceholder: 'Välj år',
      quarterPlaceholder: 'Välj kvartal',
      monthPlaceholder: 'Välj månad',
      weekPlaceholder: 'Välj vecka',
      rangePlaceholder: [
        'Startdatum',
        'Slutdatum',
      ],
      rangeYearPlaceholder: [
        'Startår',
        'Slutår',
      ],
      rangeMonthPlaceholder: [
        'Startmånad',
        'Slutmånad',
      ],
      rangeWeekPlaceholder: [
        'Startvecka',
        'Slutvecka',
      ],
      locale: 'sv_SE',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Till idag',
      ok: 'Ok',
      clear: 'Avbryt',
      month: 'Månad',
      year: 'År',
      timeSelect: 'Välj tidpunkt',
      dateSelect: 'Välj datum',
      monthSelect: 'Välj månad',
      yearSelect: 'Välj år',
      decadeSelect: 'Välj årtionde',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-MM-DD H:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Förra månaden (PageUp)',
      nextMonth: 'Nästa månad (PageDown)',
      previousYear: 'Föreg år (Control + left)',
      nextYear: 'Nästa år (Control + right)',
      previousDecade: 'Föreg årtionde',
      nextDecade: 'Nästa årtionde',
      previousCentury: 'Föreg århundrade',
      nextCentury: 'Nästa århundrade',
    },
    timePickerLocale: {
      placeholder: 'Välj tid',
    },
  },
  TimePicker: {
    placeholder: 'Välj tid',
  },
  Calendar: {
    lang: {
      placeholder: 'Välj datum',
      yearPlaceholder: 'Välj år',
      quarterPlaceholder: 'Välj kvartal',
      monthPlaceholder: 'Välj månad',
      weekPlaceholder: 'Välj vecka',
      rangePlaceholder: [
        'Startdatum',
        'Slutdatum',
      ],
      rangeYearPlaceholder: [
        'Startår',
        'Slutår',
      ],
      rangeMonthPlaceholder: [
        'Startmånad',
        'Slutmånad',
      ],
      rangeWeekPlaceholder: [
        'Startvecka',
        'Slutvecka',
      ],
      locale: 'sv_SE',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Till idag',
      ok: 'Ok',
      clear: 'Avbryt',
      month: 'Månad',
      year: 'År',
      timeSelect: 'Välj tidpunkt',
      dateSelect: 'Välj datum',
      monthSelect: 'Välj månad',
      yearSelect: 'Välj år',
      decadeSelect: 'Välj årtionde',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-MM-DD H:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Förra månaden (PageUp)',
      nextMonth: 'Nästa månad (PageDown)',
      previousYear: 'Föreg år (Control + left)',
      nextYear: 'Nästa år (Control + right)',
      previousDecade: 'Föreg årtionde',
      nextDecade: 'Nästa årtionde',
      previousCentury: 'Föreg århundrade',
      nextCentury: 'Nästa århundrade',
    },
    timePickerLocale: {
      placeholder: 'Välj tid',
    },
  },
  global: {
    placeholder: 'Vänligen välj',
  },
  Table: {
    filterTitle: 'Filtermeny',
    filterConfirm: 'OK',
    filterReset: 'Återställ',
    filterEmptyText: 'Inga filter',
    emptyText: 'Ingen data',
    selectAll: 'Markera nuvarande sida',
    selectInvert: 'Invertera nuvarande sida',
    selectNone: 'Avmarkera all data',
    selectionAll: 'Markera all data',
    sortTitle: 'Sortera',
    expand: 'Expandera rad',
    collapse: 'Komprimera rad',
    triggerDesc: 'Klicka för att sortera i fallande ordning',
    triggerAsc: 'Klicka för att sortera i stigande ordning',
    cancelSort: 'Klicka för att avbryta sortering',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Avbryt',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Avbryt',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Sök här',
    itemUnit: 'objekt',
    itemsUnit: 'objekt',
    remove: 'Ta bort',
    selectCurrent: 'Markera nuvarande sida',
    removeCurrent: 'Ta bort nuvarande sida',
    selectAll: 'Markera all data',
    removeAll: 'Ta bort all data',
    selectInvert: 'Invertera nuvarande sida',
  },
  Upload: {
    uploading: 'Laddar upp...',
    removeFile: 'Ta bort fil',
    uploadError: 'Uppladdningsfel',
    previewFile: 'Förhandsgranska fil',
    downloadFile: 'Ladda ned fil',
  },
  Empty: {
    description: 'Ingen data',
  },
  Icon: {
    icon: 'ikon',
  },
  Text: {
    edit: 'Redigera',
    copy: 'Kopiera',
    copied: 'Kopierad',
    expand: 'Expandera',
  },
  PageHeader: {
    back: 'Tillbaka',
  },
  Form: {
    optional: '(valfritt)',
    defaultValidateMessages: {
      default: 'Fältvalideringsfel för ${label}',
      required: 'Vänligen fyll i ${label}',
      enum: '${label} måste vara en av [${enum}]',
      whitespace: '${label} kan inte vara ett tomt tecken',
      date: {
        format: '${label} datumformatet är ogiltigt',
        parse: '${label} kan inte konverteras till ett datum',
        invalid: '${label} är ett ogiltigt datum',
      },
      types: {
        string: '${label} är inte en giltig ${type}',
        method: '${label} är inte en giltig ${type}',
        array: '${label} är inte en giltig ${type}',
        object: '${label} är inte en giltig ${type}',
        number: '${label} är inte en giltig ${type}',
        date: '${label} är inte en giltig ${type}',
        boolean: '${label} är inte en giltig ${type}',
        integer: '${label} är inte en giltig ${type}',
        float: '${label} är inte en giltig ${type}',
        regexp: '${label} är inte en giltig ${type}',
        email: '${label} är inte en giltig ${type}',
        url: '${label} är inte en giltig ${type}',
        hex: '${label} är inte en giltig ${type}',
      },
      string: {
        len: '${label} måste vara ${len} tecken',
        min: '${label} måste vara minst ${min} tecken',
        max: '${label} måste vara högst ${max} tecken',
        range: '${label} måste vara mellan ${min}-${max} tecken',
      },
      number: {
        len: '${label} måste vara lika med ${len}',
        min: '${label} måste vara minst ${min}',
        max: '${label} måste vara högst ${max}',
        range: '${label} måste vara mellan ${min}-${max}',
      },
      array: {
        len: 'Måste vara ${len} ${label}',
        min: 'Minst ${min} ${label}',
        max: 'Högst ${max} ${label}',
        range: 'Antal ${label} måste vara mellan ${min}-${max}',
      },
      pattern: {
        mismatch: '${label} stämmer inte överens med mönstret ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Förhandsgranska',
  },
};

export default localeValues;
